// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    EvidenceStatusEnum,
    EvidenceStatusEnumFromJSON,
    EvidenceStatusEnumToJSON,
    SupportEvidenceType,
    SupportEvidenceTypeFromJSON,
    SupportEvidenceTypeToJSON,
    SupportFacility,
    SupportFacilityFromJSON,
    SupportFacilityToJSON,
    SupportPayer,
    SupportPayerFromJSON,
    SupportPayerToJSON,
    SupportProvider,
    SupportProviderFromJSON,
    SupportProviderToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportEvidence
 */
export interface SupportEvidence {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportEvidence
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportEvidence
     */
    created?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportEvidence
     */
    updated?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportEvidence
     */
    documentId?: string;
    /**
     * 
     * OpenAPI data type: {SupportEvidenceType}
     * @type {SupportEvidenceType}
     * @memberof SupportEvidence
     */
    evidenceType?: SupportEvidenceType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportEvidence
     */
    notes?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportEvidence
     */
    expired?: string;
    /**
     * 
     * OpenAPI data type: {EvidenceStatusEnum}
     * @type {EvidenceStatusEnum}
     * @memberof SupportEvidence
     */
    status?: EvidenceStatusEnum;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportEvidence
     */
    approveByUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportEvidence
     */
    approved?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportEvidence
     */
    denyByUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportEvidence
     */
    denied?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportEvidence
     */
    denyReason?: string;
    /**
     * 
     * OpenAPI data type: {SupportPayer}
     * @type {SupportPayer}
     * @memberof SupportEvidence
     */
    primaryPayer?: SupportPayer;
    /**
     * 
     * OpenAPI data type: {SupportProvider}
     * @type {SupportProvider}
     * @memberof SupportEvidence
     */
    billingProvider?: SupportProvider;
    /**
     * 
     * OpenAPI data type: {SupportProvider}
     * @type {SupportProvider}
     * @memberof SupportEvidence
     */
    renderingProvider?: SupportProvider;
    /**
     * 
     * OpenAPI data type: {SupportFacility}
     * @type {SupportFacility}
     * @memberof SupportEvidence
     */
    facility?: SupportFacility;
}

export function SupportEvidenceFromJSON(json: any): SupportEvidence {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'created': !exists(json, 'created') ? undefined : json['created'],
            'updated': !exists(json, 'updated') ? undefined : json['updated'],
            'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
            'evidenceType': !exists(json, 'evidenceType') ? undefined : SupportEvidenceTypeFromJSON(json['evidenceType']),
            'notes': !exists(json, 'notes') ? undefined : json['notes'],
            'expired': !exists(json, 'expired') ? undefined : json['expired'],
            'status': !exists(json, 'status') ? undefined : EvidenceStatusEnumFromJSON(json['status']),
            'approveByUserId': !exists(json, 'approveByUserId') ? undefined : json['approveByUserId'],
            'approved': !exists(json, 'approved') ? undefined : json['approved'],
            'denyByUserId': !exists(json, 'denyByUserId') ? undefined : json['denyByUserId'],
            'denied': !exists(json, 'denied') ? undefined : json['denied'],
            'denyReason': !exists(json, 'denyReason') ? undefined : json['denyReason'],
            'primaryPayer': !exists(json, 'primaryPayer') ? undefined : SupportPayerFromJSON(json['primaryPayer']),
            'billingProvider': !exists(json, 'billingProvider') ? undefined : SupportProviderFromJSON(json['billingProvider']),
            'renderingProvider': !exists(json, 'renderingProvider') ? undefined : SupportProviderFromJSON(json['renderingProvider']),
            'facility': !exists(json, 'facility') ? undefined : SupportFacilityFromJSON(json['facility']),
    };

}

export function SupportEvidenceToForm(value?: SupportEvidence): any {
    let jsonVal = SupportEvidenceToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportEvidenceToJSON(value?: SupportEvidence): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'created': cleanupBlankValuesForBackend(value.created),
            'updated': cleanupBlankValuesForBackend(value.updated),
            'documentId': cleanupBlankValuesForBackend(value.documentId),
            'evidenceType': SupportEvidenceTypeToJSON(value.evidenceType),
            'notes': cleanupBlankValuesForBackend(value.notes),
            'expired': cleanupBlankValuesForBackend(value.expired),
            'status': EvidenceStatusEnumToJSON(value.status),
            'approveByUserId': cleanupBlankValuesForBackend(value.approveByUserId),
            'approved': cleanupBlankValuesForBackend(value.approved),
            'denyByUserId': cleanupBlankValuesForBackend(value.denyByUserId),
            'denied': cleanupBlankValuesForBackend(value.denied),
            'denyReason': cleanupBlankValuesForBackend(value.denyReason),
            'primaryPayer': SupportPayerToJSON(value.primaryPayer),
            'billingProvider': SupportProviderToJSON(value.billingProvider),
            'renderingProvider': SupportProviderToJSON(value.renderingProvider),
            'facility': SupportFacilityToJSON(value.facility),
    };
}


